import { createAction, props } from '@ngrx/store';
export const setConfirmationDetails = createAction(
  '[Confirmation Flow] Set Confirmation Details',
  props<{confirmationId: string; isInterestedParty: boolean; confirmationDate: string; description: string; }>()
);
export const setRecipient = createAction(
  '[Confirmation Flow] Set Recipient',
  props<{
    confirmationId: string;
    confirmationDate: string;
    description: string;
    name: string;
    address: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    city: string;
    stateCode: string;
    zipCode: string;
    zipCodePlusFour: string;
    foreign: boolean;
    foreignAddressText: string;
    countryCode: string;
    countryName: string;
  }>()
);

export const setStepIndicatorIndex = createAction(
  '[Confirmation Flow] Set Step Indicator Index',
  props<{ stepIndicatorIndex: number }>()
);
